import { Modal } from "../../common/Modal";

type DevicesSearchHelpModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const DevicesSearchHelpModal = ({
  isOpen,
  onClose,
}: DevicesSearchHelpModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Aide à la recherche"
      icon="info-circle"
      maxWidth="lg"
    >
      <div className="space-y-3 text-sm text-default-text">
        <p className="font-oxaniumMedium">
          Règles de base pour la recherche dans les produits :
        </p>
        <ul className="list-disc pl-5 space-y-1">
          <li>
            <span className="font-oxaniumMedium">OU</span> : utilisez le
            caractère <code>|</code> entre deux termes (ex :{" "}
            <code>serenity|avitouch</code>).
          </li>
          <li>
            <span className="font-oxaniumMedium">ET explicite</span> : utilisez
            le caractère <code>+</code> (ex : <code>serenity+France</code>).
          </li>
          <li>
            <span className="font-oxaniumMedium">Exclusion</span> : préfixez un
            terme avec <code>-</code> (ex : <code>-inactive</code> pour exclure
            les produits inactifs).
          </li>
          <li>
            <span className="font-oxaniumMedium">Expression exacte</span> :
            mettez la recherche entre guillemets (ex :{" "}
            <code>"Bâtiment Nord"</code>).
          </li>
        </ul>

        <p className="font-oxaniumMedium">Champs pris en compte :</p>
        <p>
          Type de produit, nom du produit, entreprise, élevage, bâtiment, UUID,
          IP locale/VPN, pays, version, statut, version du noyau.
        </p>

        <p className="font-oxaniumMedium">Types de produit possibles :</p>
        <p>serenity, avitouch, avibox, labelbox, vigebox.</p>

        <p className="font-oxaniumMedium">Export CSV :</p>
        <p>
          Le bouton gris avec l&apos;icône de téléchargement exporte{" "}
          <span className="font-oxaniumMedium">
            uniquement les lignes actuellement filtrées
          </span>{" "}
          au format CSV.
        </p>
      </div>
    </Modal>
  );
};

